var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "test_list_wrap"
    },
    [
      _vm.userType == 0 || _vm.userType == 1
        ? _c(
            "div",
            { staticClass: "teacher_test_list_table" },
            [
              _c(
                "el-table",
                {
                  staticClass: "collegeTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    "tooltip-effect": "dark",
                    height: _vm.height,
                    "header-cell-style": _vm.headerCellStyle,
                    "empty-text": _vm.empty
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "paperName", label: "考试名称" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "总分" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(scope.row.totalScore.split(".")[0]) +
                                    "分/" +
                                    _vm._s(scope.row.totalQuestion) +
                                    "题"
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3820229202
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "examTime", label: "考试时长" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "examCount", label: "考试时间" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n\t      \t\t" +
                                  _vm._s(
                                    scope.row.examStartTime.substring(0, 10)
                                  ) +
                                  "~" +
                                  _vm._s(
                                    scope.row.examEndTime.substring(0, 10)
                                  ) +
                                  "\n\t      \t"
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1327984297
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "notSumbit", label: "未提交", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "sumbit", label: "已提交", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "平均分", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.average) + "分")
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3609307080
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "操作", width: "240" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { round: "", size: "small" },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.previewRow(
                                        scope.$index,
                                        _vm.tableData
                                      )
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { round: "", size: "small" },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.seeRow(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("查看")]
                              ),
                              _vm._v(" "),
                              scope.row.answerStatus == 0 &&
                              scope.row.answerPublishStatus == 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { round: "", size: "small" },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.publishAnswer(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("公布答案")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1732664571
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userType == 2 || _vm.userType == 3
        ? _c(
            "div",
            {
              staticClass: "student_test_list_table",
              style: "height:" + (_vm.height + 50) + "px"
            },
            [
              _vm.tableData.length > 0
                ? _c(
                    "ul",
                    { style: "height:" + (_vm.height - 5) + "px" },
                    _vm._l(_vm.tableData, function(item, i) {
                      return _c("li", { key: i }, [
                        _c("div", { staticClass: "left" }, [
                          _c("p", [
                            _vm._v("【" + _vm._s(item.paperName) + "】")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "bottom" }, [
                            _c("span", { staticClass: "exam" }, [
                              _vm._v(
                                _vm._s(item.totalScore.split(".")[0]) +
                                  "分/" +
                                  _vm._s(item.totalQuestion) +
                                  "题"
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "考试时间：" +
                                  _vm._s(item.examStartTime.substring(0, 10)) +
                                  "——" +
                                  _vm._s(item.examEndTime.substring(0, 10))
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "考试时长：" + _vm._s(item.examTime) + "分钟"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: _vm.handleExamStatus(item.examStatus, 3)
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.handleExamStatus(
                                      item.examStatus,
                                      2
                                    )
                                  }
                                }),
                                _vm._v(
                                  _vm._s(
                                    _vm.handleExamStatus(item.examStatus, 1)
                                  )
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn" },
                          [
                            item.userPaperStatus == "answerDetail"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled:
                                        item.buttonStatus == 0 ? true : false
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.answerDetails(item)
                                      }
                                    }
                                  },
                                  [_vm._v("作答详情")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.userPaperStatus == "continueQuestion"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "answer",
                                    on: {
                                      click: function($event) {
                                        return _vm.giveResponse(
                                          item.userPaperStatus,
                                          item,
                                          false
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("继续作答")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.userPaperStatus == "startQuestion"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "answer",
                                    attrs: {
                                      disabled:
                                        item.buttonStatus == 0 ? true : false
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.giveResponse(
                                          item.userPaperStatus,
                                          item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("开始考试")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.userPaperStatus == "notSubmit"
                              ? _c("el-button", { attrs: { disabled: "" } }, [
                                  _vm._v("未提交")
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                : _c("div", { staticClass: "no_list" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../../../static/images/wujieguo.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无数据")])
                  ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68e9f81b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e9f81b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/examination/index.vue
// module id = null
// module chunks = 